import { z } from 'zod';
export const AnticipoSchema = z.object({
    id: z.string().uuid(),
    tipo: z.enum(['INSTRUCTOR', 'PROMOTOR']),
    personaId: z.string().uuid().nullable().optional(),
    personaNombre: z.string(),
    monto: z.union([z.string(), z.number()]),
    montoImputado: z.union([z.string(), z.number()]),
    saldoPendiente: z.union([z.string(), z.number()]),
    fecha: z.string(),
    observaciones: z.string().nullable().optional(),
    imputadoEnLliqId: z.string().uuid().nullable().optional(),
    creadoEn: z.string(),
});
export const AnticipoFormSchema = z.object({
    tipo: z.enum(['INSTRUCTOR', 'PROMOTOR']),
    personaId: z.string().uuid('Elegí una persona'),
    monto: z.string().min(1, 'Requerido'),
    fecha: z.string().min(1, 'Requerido'),
    observaciones: z.string().max(500).optional().or(z.literal('')),
});
